import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { ProductsService } from 'app/_services/products.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-product-nutrition',
    templateUrl: './product-nutrition.component.html',
    styleUrls: ['./product-nutrition.component.css']
})
export class ProductNutritionComponent implements OnInit {

    tabitems: any = [];

    productId: any;
    selectedProduct: any;
    productForm: FormGroup;

    role: any;
    routeRole: any;

    text: any;
    storeId: any;
    cookieStore: any;

    constructor(
        public fb: FormBuilder,
        public activatedRoute: ActivatedRoute,
        public loader: LoadingBarService,
        public notificationService: NotificationService,
        public globals: Globals,
        public _productsService: ProductsService,
        public cookieService: CookieService,
        public router: Router
    ) {
        // Get Patient id from params
        this.activatedRoute.params.subscribe((params: Params) => {
            this.productId = params.id;
        });

        // Handle Store Cookies
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
        }

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        this.tabitems = [
            { path: '/' + this.routeRole + '/products/', title: 'All Products', class: 'back-link' },
            { path: '/' + this.routeRole + '/products/' + this.productId + '/details', title: 'Details' },
            { path: '/' + this.routeRole + '/products/' + this.productId + '/images', title: 'Images' },
            { path: '/' + this.routeRole + '/products/' + this.productId + '/nutrition', title: 'Nutrition' },
            { path: '/' + this.routeRole + '/products/' + this.productId + '/ingredients-allergens', title: 'Ingredients & Allergens' }
        ];

    }

    ngOnInit() {
        this.getProduct(this.productId);
    }

    // Get Product by id
    public getProduct(id) {
        this._productsService.getProductById(id)
            .subscribe((data: any) => {
                console.log('Indi Product ', data);
                this.selectedProduct = data;
                this.text = data.nutrition;
            })
    }

    public save() {
        this.selectedProduct.nutrition = this.text;
        if (!this.text) {
            this.selectedProduct.nutrition = '';
        }
        this._productsService.editProduct(this.selectedProduct)
            .subscribe((data: any) => {
                console.log(data);
                this.getProduct(this.productId);
                this.notificationService.notify(
                    'success',
                    'Nutrition Updated',
                    'Product nutrition has successfully been updated',
                    'top',
                    'right');
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/products/single-product/nutrition/product-nutrition.component.ts